<template>
  <div class="data-list-container">
    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="customStaticPopup"
      :class="{ show: customStaticPopup }"
    >
      <div class="cstm-modal medium fixed_medium">
        <div class="header">
          <h4>{{ modelname }}</h4>
          <button @click.stop="closePopupNoteModal" class="close-modal">
            &times;
          </button>
        </div>
        <div
          style="max-height: calc(100vh - 100px); overflow-y: auto"
          class="vertical_scrollbar"
        >
          <vs-tabs class="unique_cstm_tab">
            <vs-tab :label="modelname == 'Staff' ? modelname : 'Parent'">
              <vs-card class="cstm_vx_card">
                <div
                  slot="header"
                  class="flex flex-wrap justify-between items-center"
                >
                  <h4>Static Fields</h4>
                </div>

                <vx-card
                  style="margin: 15px"
                  v-for="field in staticFields"
                  :key="field.field_id"
                >
                  <vs-row vs-w="12">
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      vs-lg="2"
                      vs-sm="6"
                      vs-xs="6"
                    >
                      <b class="text-primary">{{ field.field_label }}</b>
                      <br />
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      vs-lg="2"
                      vs-sm="6"
                      vs-xs="3"
                    >
                      <!-- <b class="text-primary">{{ field.inputtype }}</b> -->
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="left"
                      vs-lg="2"
                      vs-sm="6"
                      vs-xs="3"
                    >
                      <vs-checkbox
                        :disabled="field.is_always_required == 1"
                        v-model="field.enabled_parent"
                        :checked="field.enabled_parent"
                        :value="field.enabled_parent"
                        @input="fieldRequired(0, field)"
                        >Required</vs-checkbox
                      >
                    </vs-col>
                  </vs-row>
                </vx-card>
              </vs-card>
            </vs-tab>
            <vs-tab label="Child" v-if="staticChildFields.length > 0">
              <vs-card class="cstm_vx_card">
                <div
                  slot="header"
                  class="flex flex-wrap justify-between items-center"
                >
                  <h4>Static Fields</h4>
                </div>

                <vx-card
                  style="margin: 15px"
                  v-for="field in staticChildFields"
                  :key="field.field_id"
                >
                  <vs-row vs-w="12">
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      vs-lg="2"
                      vs-sm="6"
                      vs-xs="6"
                    >
                      <b class="text-primary">{{ field.field_label }}</b>
                      <br />
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      vs-lg="2"
                      vs-sm="6"
                      vs-xs="3"
                    >
                      <!-- <b class="text-primary">{{ field.inputtype }}</b> -->
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="left"
                      vs-lg="2"
                      vs-sm="6"
                      vs-xs="3"
                    >
                      <vs-checkbox
                        :disabled="field.is_always_required == 1"
                        v-model="field.enabled_child"
                        :checked="field.enabled_child"
                        :value="field.enabled_child"
                        @input="fieldRequired(1, field)"
                        >Required</vs-checkbox
                      >
                    </vs-col>
                  </vs-row>
                </vx-card>
              </vs-card>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </div>
    <!-- {{custom_fields}} -->
  </div>
</template>
<script>
import { fetchCustomStaticFields, saveChecked } from '@/api/customfield'
import vSelect from 'vue-select'

// import Vue from 'vue'

export default {
  components: {
    vSelect
  },

  name: 'custom-value-list-module-view',
  props: {
    modelname: {
      default: ''
    },
    customStaticPopup: {
      default: false
    },
    table_name:{
      default:''
    },
    module_id:{
      default:null
    }
  },
  data () {
    return {
      staticFields: [],
      staticChildFields: [],
      modulename: this.modelname,
      is_required: ''
    }
  },
  mounted () {
    this.fetch_list()
  },

  methods: {
    closePopupNoteModal () {
      this.$emit('closeCustomModal', true)
    },
    async fetch_list () {
      //   this.$vs.loading()
      this.$vs.loading({ text: 'Fetching Static Fields' })

      try {
        const payload = {table_name: this.table_name}

        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(
          this.module_id,
          customerId,
          payload
        )
        //

        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields

        //
      } catch (e) {
        this.$router.push({ name: 'v1-settings' }).catch(() => {})
        // this.$vs.loading.close()
      } finally {
        this.$vs.loading.close()
      }
    },
    async fieldRequired (id, field) {
      if (id === 0) {
        this.is_required = field.enabled_parent === true ? 1 : 0
      }
      if (id === 1) {
        this.is_required = field.enabled_child === true ? 1 : 0
      }
      const payload = {
        customer_id: this.$store.getters.customerId,
        field_id: field.field_id,
        is_required: this.is_required,
        is_child: id
      }
      await saveChecked(payload)
      this.$vs.notify({
        title: 'Success',
        text: 'Static Field updated Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    }
  }
}
</script>

<style>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}

/* .vs-sidebar .vs-sidebar--items{
    overflow-y: scroll !important;
  } */

.gb-vue-timeline-update__title {
  font-size: 14px !important;
  margin-left: -12px !important;
}

.gb-vue-timeline-update__ago {
  margin-right: -9%;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  box-shadow: 7px 3px 15px #c7c6c6;
}
</style>
